import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux'
import SearchBar from '../Components/SearchBar'
import { Form, FormControl } from 'react-bootstrap';
import env from '../ENV';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {GetGRNDetails} from '../store/actions/dispatchOrderDetailsActions'
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'

const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

function formatDate(date) {
    var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
    if (month.length < 2) 
    month = '0' + month;
    if (day.length < 2) 
    day = '0' + day;
    return [day, month, year].join('-');
  }
  
  class GRNPO extends React.Component {

    constructor(props) {
        super(props);
        this.state={
        allChecked: false,
        supplierName: "ABC Tech Inc.",
        select: true,
        checkbox:false,
        open: false,
        checked: [],
        opacity:"",
        comments:'',
        formattedData: [],
        selectAll: false,
       
        array2: [
            {  value: 1, id:1, PoNo: "4700026941", PoName: "ABC" ,POAmount:"98862", PoDate: "12-06-2020" , status: "Not Initiated", WBSNo: "A0XXXX", totalPoQuantity: "50" , quantityToDispatch: "" , itemDescription: "STAND TILTING DEVICE" , dispatchConditions: "DAP", arrangeTransport: "SMS", proposedDate: "" },
            {  value: 2, id:2, PoNo: "4700026942", PoName: "ABC" ,POAmount:"98862", PoDate: "11-01-2020" , status: "Not Initiated", WBSNo: "A0XXX0", totalPoQuantity: "90" , quantityToDispatch: "" , itemDescription: "TRANSFER DEVICE, CROSS" , dispatchConditions: "EXW", arrangeTransport: "Supplier", proposedDate:  ""},
            {  value: 3, id:3, PoNo: "4700026943", PoName: "ABC" ,POAmount:"98862", PoDate: "12-03-2020" , status: "Not Initiated", WBSNo: "AQUXXX", totalPoQuantity: "100", quantityToDispatch: "" , itemDescription: "TOP FRAME" ,   dispatchConditions: "DAP", arrangeTransport: "Supplier", proposedDate: ""  },
            {  value: 4, id:4, PoNo: "4700026944", PoName: "ABC" ,POAmount:"98862", PoDate: "01-08-2020" , status: "Not Initiated", WBSNo: "A0YAAX", totalPoQuantity: "145", quantityToDispatch: "" , itemDescription: "LOOSE SLIDE" , dispatchConditions: "EXW", arrangeTransport: "SMS", proposedDate: ""},
        ]       
      }
      // this.dateformate = this.dateformate.bind(this);
      
      this.togglebutton = this.togglebutton.bind(this); 
      
    }

    
    componentDidMount(){
      this.props.GetGRNDetails()
    }  

   

    

    action1() {
             this.setState({ action1: false });
             } 

    togglebutton=(Index)=> {  
      
      var multiCollapseIndex = this.state.multiCollapseIndex
  
      if(multiCollapseIndex!=Index || multiCollapseIndex==''){
        this.setState({multiCollapseIndex:Index})
    }}

    


      

    render()
    {

      console.log(this.props.GRNHeader.getGRNdata.recordset)
        return(
                        
            <div className="Container-fluid pageheight"  >
               
               <div className="Container-fluid p-4" >

                <div className="row pr-4" >
                    <div className="col-md-8 header ">
                  </div>
                    
                    <div className="col pt-2  xs={last}">
                    <SearchBar placeholder="Search"  label="Search"  btnName=""  />
                    </div>
                </div>
                
              <div className="row-md-8 pr-4">
                <div className="col ">
                    <div className="row  headerbar ">
                   
                          
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar">PO Number</div>
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar ">PO Amount</div>
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar">Created On</div>
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar">Action </div>
                    </div>

                    {this.props.GRNHeader.getGRNdata && this.props.GRNHeader.getGRNdata.recordset && this.props.GRNHeader.getGRNdata.recordset.map((element,Index)=>

                        // {this.state.array2.map((element,Index)=>
                            <div className={Index%2==0? 'row border ':'row  background '} >
                            
                            <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign">{element.POSAPId}</div>
                            <div className="col-md-3 pt-2 pb-2 borderheaderbar amount-text headeralign">{numberWithCommas(element.Currency+" "+element.POAmount)}</div>
                            <div className="col-md-3 pt-2 pb-2 borderheaderbar d-none d-sm-block">{dateFormater(element.POCreationDate)}</div>
                            <div className="col-md-3 pt-2 pb-2 borderheaderbar text-center d-none d-sm-block">            
                                <Link to= {{ pathname: '/GRNPOItem',state : {poId: element.PurchaseOrderId} }}>
                                  <FontAwesomeIcon icon={"eye"}  color="black" title="View" size="lg" />
                                </Link>
                           </div>
                            
                      
                         
                          </div>
                    )}  
                        <br/> 
                        <br/>        
                    
                  </div>
            </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps  = (state) => ({GRNHeader: state.dispatchOrderDetailsReducer})
export default connect(mapStateToProps,{GetGRNDetails}) (GRNPO)
